import { Button, Message, Modal } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import React from 'react';

export default function DownloadFileModal({ open, setOpenModal, file, handleDownloadFile }) {
    const { t } = useTranslation();

    const textLabelAndMessage = () =>
        React.useMemo(() => {
            switch (true) {
                case file.status === 'building':
                    return {
                        label: t('ticket.moderation.filesManagement.downloadModal.buildingTitle'),
                        message: t('ticket.moderation.filesManagement.downloadModal.buildingMessage')
                    };
                case file.count_downloads > 0:
                    return {
                        label: t('ticket.moderation.filesManagement.downloadModal.alreadyDownloadedTitle'),
                        message: t('ticket.moderation.filesManagement.downloadModal.alreadyDownloadedMessage')
                    };
                default:
                    return {
                        label: '',
                        message: ''
                    };
            }
        }, [file]);

    return (
        <Modal
            size="large"
            open={open}
            onClose={() => setOpenModal(false)}
            title={t('ticket.moderation.filesManagement.downloadModal.title')}
            allowExternalClosing={false}
            customFooter={
                <Button.Group>
                    <Button label={t('ticket.common.action.back')} onClick={() => setOpenModal(false)} />
                    <Button primary label={t('ticket.common.action.continue')} onClick={() => handleDownloadFile(file.id)} />
                </Button.Group>
            }
        >
            <Message title={textLabelAndMessage().label} type="warning" visible>
                {textLabelAndMessage().message}
            </Message>
        </Modal>
    );
}
